// src/components/drawer/drawer.styles.ts
import { tv } from "tailwind-variants";
var drawerHeaderStyles = tv({
  base: "border-b p-4 text-center"
});
var drawerBodyStyles = tv({
  base: "p-4 overflow-auto"
});
var drawerFooterStyles = tv({
  base: "shadow-[0px_-6px_24px_0px_rgba(155,156,157,0.25)] p-4 mt-4 flex gap-2 bg-main",
  variants: {
    sticky: {
      true: "sticky bottom-0",
      false: ""
    }
  }
});
var drawerContentStyles = tv({
  slots: {
    content: "bg-main fixed bottom-0 left-0 right-0 max-h-[98vh] min-h-40 rounded-t-3xl outline-none flex flex-col z-30",
    handle: "bg-neutral-20 w-28 h-1 mx-auto rounded-full mt-2"
  }
});
var drawerTitleStyles = tv({
  base: "text-lg font-semibold"
});
export {
  drawerBodyStyles,
  drawerContentStyles,
  drawerFooterStyles,
  drawerHeaderStyles,
  drawerTitleStyles
};
